<app-item-base [open]="open">
  <p class="name" placement="right">
    BP
  </p>
  <div class="edit-field">
    <select class="form-control-select" [(ngModel)]="this.searchParams.bp_rank" name="bp_rank"
      [ngClass]="{ 'search-active': searchParams.bp_rank !== '0' }">
      <option value="0" selected="">-</option>
      <option value="1">★〜</option>
      <option value="2">★★〜</option>
      <option value="3">★★★〜</option>
      <option value="4">★★★★〜</option>
      <option value="5">★★★★★〜</option>
    </select>
  </div>
</app-item-base>